import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'

const BillingInvoicesContainer = () => {
  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={translate('navBar.billingInvoicesTitle')}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default BillingInvoicesContainer
